import { Volume2, VolumeX } from "lucide-react";
import { useMusic } from "./MusicContext";

const MusicPlayer = () => {
  const { isPlaying, toggle } = useMusic();

  return (
    <button
      data-testid="music-toggle"
      onClick={(e) => { e.stopPropagation(); toggle(); }}
      className="fixed bottom-6 left-6 z-50 w-12 h-12 rounded-full bg-white/80 backdrop-blur-md border border-sand flex items-center justify-center shadow-soft hover:bg-gold hover:text-white hover:border-gold transition-all duration-300 group"
      aria-label={isPlaying ? "Mute" : "Play music"}
    >
      {isPlaying ? (
        <Volume2 className="w-5 h-5 text-charcoal group-hover:text-white" strokeWidth={1.5} />
      ) : (
        <VolumeX className="w-5 h-5 text-charcoal group-hover:text-white" strokeWidth={1.5} />
      )}
      {isPlaying && (
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-gold animate-pulse" />
      )}
    </button>
  );
};

export default MusicPlayer;
